// src/admin/views/GolferListView.js
import { useEffect, useState } from 'react'
import { FiPlus } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

function GolferListView() {
  const [golferData, setGolferData] = useState([])
  const orgName = useAdminStore((state) => state.orgName)
  const orgId = useAdminStore((state) => state.orgId)
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    // Fetch golfer data from the API when the component mounts
    apiClient.get(`/gskapi/golfers/org/${orgId}`)
      .then((response) => {
        const sortedGolfers = response.data.sort((a, b) => {
          if (a.inactive !== b.inactive) return a.inactive ? 1 : -1;
          if (!a.inactive && !b.inactive) {
            const aComp = a.competitor !== false;
            const bComp = b.competitor !== false;
            if (aComp !== bComp) return aComp ? -1 : 1;
          }
          return (a.golferName || '').localeCompare(b.golferName || '');
        });
        setGolferData(sortedGolfers)
      })
      .catch((error) => {
        console.error('Error fetching golfer data:', error)
      })
  }, [])

  return (
    <>
      <PageHeader backTo={'/admin'} pageName={'Golfers'} />
      {orgName && (
        <div style={{ textAlign: 'center', fontWeight: 'bold', margin: '10px 0' }}>
          {orgName}
        </div>
      )}
      <div className="add-button-container" style={{ marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={() => navigate(`/admin/golfer`)}>
          <FiPlus style={{ marginRight: '8px' }} /> Add Golfer
        </button>
      </div>
      <div className="admin-list">
        {golferData.map((golfer) => (
          <div
            key={golfer.golferId}
            className="admin-list-item"
            onClick={() => navigate(`/admin/golfer?golferId=${golfer.golferId}`)}
          >
            <span
              className="admin-list-item-name"
              style={golfer.inactive ? { color: '#8a8a8a' } : (golfer.competitor === false ? { color: 'darkred' } : {})}
            >
              {golfer.golferName}
            </span>
            <span className="admin-list-item-arrow">›</span>
          </div>
        ))}
      </div>
    </>
  )
}

export default GolferListView
